import { render, staticRenderFns } from "./OrganizationDropdown.vue?vue&type=template&id=71895b60&scoped=true&"
import script from "./OrganizationDropdown.vue?vue&type=script&lang=js&"
export * from "./OrganizationDropdown.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationDropdown.vue?vue&type=style&index=0&id=71895b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71895b60",
  null
  
)

export default component.exports